/**
 * Created by ivo on 13.05.17.
 */
class AppServices {

    static instance;

    constructor() {
        if (this.instance) return this.instance;
        this.services = {};
        this.instance = this;
    }

    setup(services) {
        this.services = services;
    }

    /**
     * RestApi object
     * @returns {RestApi}
     */
    getRestApi() {
        return this.services.restApi;
    }

    getSessionStore() {
        return this.services.sessionStore;
    }

}

export default new AppServices();
